<h2>Create search for new property</h2>
@if (showFirstTimeBuyerButton) {
  <shared-button-with-image
    headline="First time buyer"
    contentStyleClass="bg-gray-5 w-100"
    [isSelected]="
      stepFormGroup.value.type ===
      ENUM_SmartSearchPropertyPurchaseType.SMART_SEARCH_PROPERTY_PURCHASE_TYPE_FIRST_TIME_BUYER
    "
    (click)="
      setValue(
        ENUM_SmartSearchPropertyPurchaseType.SMART_SEARCH_PROPERTY_PURCHASE_TYPE_FIRST_TIME_BUYER
      )
    " />
}
<shared-button-with-image
  headline="Moving home"
  contentStyleClass="bg-gray-5 w-100"
  [isSelected]="
    stepFormGroup.value.type ===
    ENUM_SmartSearchPropertyPurchaseType.SMART_SEARCH_PROPERTY_PURCHASE_TYPE_HOUSE_MOVE
  "
  [showArrowIcon]="false"
  (click)="
    setValue(ENUM_SmartSearchPropertyPurchaseType.SMART_SEARCH_PROPERTY_PURCHASE_TYPE_HOUSE_MOVE)
  " />
<shared-button-with-image
  headline="Second home"
  contentStyleClass="bg-gray-5 w-100"
  [isSelected]="
    stepFormGroup.value.type ===
    ENUM_SmartSearchPropertyPurchaseType.SMART_SEARCH_PROPERTY_PURCHASE_TYPE_SECOND_HOME
  "
  [showArrowIcon]="false"
  (click)="
    setValue(ENUM_SmartSearchPropertyPurchaseType.SMART_SEARCH_PROPERTY_PURCHASE_TYPE_SECOND_HOME)
  " />
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()" />
